import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import { SubmitBtn } from "../Styles/InputStyles";
import Loading from "../Loading";

const staticPropertyList = [
    { propId: 1, propName: "Inventory" },
    { propId: 2, propName: "Tenants" },
    { propId: 4, propName: "Banks" },
    { propId: 8, propName: "Staffs" },
    { propId: 16, propName: "Tenant Dues" },
    { propId: 32, propName: "Extra Charges" },
    { propId: 64, propName: "Expenses" },
    { propId: 128, propName: "Leads" },
    { propId: 256, propName: "Send Notice" },
    { propId: 512, propName: "Mark Attendance" },
    { propId: 1024, propName: "Collections" },
    { propId: 2048, propName: "Rest. Collections" },
    { propId: 4096, propName: "Request" },
    { propId: 8192, propName: "Reports" },

];

const CheckBox = ({ label, checked, onChange }) => (
    <label
        className={`relative flex items-center gap-3 border rounded-full px-4 py-2 transition-all cursor-pointer border-blue-300 bg-white ${checked ? "bg-blue-100 border-blue-500" : ""
            }`}
    >
        <input
            type="checkbox"
            checked={checked}
            onChange={onChange}
            className="appearance-none w-5 h-5 rounded-full border border-blue-400 focus:outline-none focus:ring-2 focus:ring-blue-300"
        />
        {checked && (
            <span className="absolute w-5 h-5 rounded-full flex justify-center items-center bg-blue-500 text-white">
                &#10004;
            </span>
        )}
        <p className="text-gray-500">{label}</p>
    </label>
);

const StaffRoleModal = ({ setOpenModel, StaffRoleMutate, StaffRoleLoading, staffsData }) => {
    console.log("staffData", staffsData);
    console.log("permissions", staffsData.permissions);

    const [checkData, setCheckData] = useState(new Map());

    useEffect(() => {
        if (staffsData && staffsData.permissions) {
            const initialCheckData = new Map();
            const permissionValue = staffsData.permissions;

            staticPropertyList.forEach((item) => {
                if ((permissionValue & item.propId) === item.propId) {
                    initialCheckData.set(item.propId, true);
                } else {
                    initialCheckData.set(item.propId, false);
                }
            });

            setCheckData(initialCheckData);
        }
    }, [staffsData]);

    const handleCheckboxChange = (propId) => {
        setCheckData((prev) => {
            const newCheckData = new Map(prev);
            newCheckData.set(propId, !prev.get(propId));
            return newCheckData;
        });
    };

    const postData = async () => {
        if (!(checkData instanceof Map)) {
            console.error("checkData is not a Map:", checkData);
            return;
        }
        StaffRoleMutate(checkData);
    };

    return (
        <Model setOpenModel={setOpenModel} width="w-11/12 max-w-lg">
            {StaffRoleLoading ? (
                <Loading />
            ) : (
                <StyledWrapper>
                    <StyledTitle>Select Permissions</StyledTitle>
                    <div className="grid grid-cols-2 gap-3 gap-y-3">
                        {staticPropertyList.map((item) => (
                            <CheckBox
                                key={item.propId}
                                label={item.propName}
                                checked={checkData.get(item.propId) || false}
                                onChange={() => handleCheckboxChange(item.propId)}
                            />
                        ))}
                    </div>
                    <BtnWrapper>
                        <SubmitBtn type="submit" onClick={postData}>
                            Submit
                        </SubmitBtn>
                    </BtnWrapper>
                </StyledWrapper>
            )}
        </Model>
    );
};

export default StaffRoleModal;

const BtnWrapper = tw.div`w-full flex items-center justify-center space-x-10 mt-8`;
const StyledWrapper = tw.div`px-8 py-6 bg-white`;
const StyledTitle = tw.h2`text-lg md:text-xl lg:text-2xl text-gray-600 font-medium mb-6 text-center`;
